module.exports = __webpack_public_path__ + "img/J0hnJ0hnn.62a984cd.jpg";